<template>
  <page>
    <div class="container-fluid">
      <h2 class="my-4"><strong>Cancellations and Refunds Policy</strong></h2>
      <p>Thanks for utilizing the services of 97tax. If you have placed an order in error, have made other arrangements, or wish to cancel your order for any reason, we’re here to help.</p>
    </div>
    <div class="col-12">
      <p class="mb-0"><strong>Cancellations</strong></p>
      <p>Due to the speed at which we begin and complete our service on new orders, there is a 1 hour timeframe after a new order is placed in which it is possible to successfully cancel your order. Cancellation requests received after 1 hour are typically not able to be cancelled because work has already progressed on your order.</p>
    </div>
    <div class="col-12">
      <p class="mb-0"><strong>How to Cancel</strong></p>
      <p>To cancel a new order within the 1 hour timeframe, send an email to <a href="mailto:support@97tax.com">support@97tax.com</a> or use the <a href="https://www.97tax.com/contact-us/">contact form</a> on this website. Both of these methods will timestamp your request.</p>
    </div>
    <div class="col-12">
      <p class="mb-0"><strong>Refunds</strong></p>
      <p>You have 1 hour after placing an order and completing payment to cancel your order. Within this time frame, you may cancel your order for any reason. To cancel, please send an email to <a href="mailto:support@97tax.com">support@97tax.com</a> or use the <a href="https://www.97tax.com/contact-us/">contact form</a> on this website. Within this 1 hour window, 97tax will issue a full refund of the purchase price.</p>
    </div>
  </page>
</template>

<!-- sharea sale tag -->
<script>
  var shareasaleSSCID=shareasaleGetParameterByName("sscid");
function shareasaleSetCookie(e,a,r,s,t){
      if(e&&a)
            {var o,n=s?"; path="+s:"",i=t?"; domain="+t:"",l="";r&&((o=new Date).setTime(o.getTime()+r),l="; expires="+o.toUTCString()),
        document.cookie=e+"="+a+l+n+i
     }}
        function shareasaleGetParameterByName(e,a)
        {a||(a=window.location.href),e=e.replace(/[\[\]]/g,"\\$&");
        var r=new RegExp("[?&]"+e+"(=([^&#]*)|&|#|$)").exec(a);
return r?r[2]?decodeURIComponent(r[2].replace(/\+/g," ")):"":null}
shareasaleSSCID&&shareasaleSetCookie("shareasaleSSCID",
shareasaleSSCID,94670778e4,"/");
</script>

<style scoped>
  a {
   font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Cancel.vue